import { atom } from "jotai";

export const isClaimDetailOpen = atom<boolean>(false);
